import { customerRoutes } from 'noddi-util';
import { useStationaryGarages } from './useStationaryGarages';

/**
 * Start path for a new booking.
 * When the brand has no stationary garages, skips `/bookings/new/choice`
 * (which would only offer home delivery) and goes straight to address.
 */
export function useNewBookingPath() {
  const { hasStationaryLocations, isLoading: isGaragesLoading } = useStationaryGarages({ withCapacity: false });

  const isMobileOnly = !isGaragesLoading && !hasStationaryLocations;

  return {
    path: isMobileOnly ? customerRoutes.newBookingAddress.getPath() : customerRoutes.newBookingChoice.getPath(),
    isMobileOnly,
    isLoading: isGaragesLoading
  };
}
